module.exports = __webpack_public_path__ + "static/media/buttonclick1.c2ff86d2.mp3";